import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout/Layout';
import { callApi } from '../../api/callApi';
import { API_ENDPOINT, API_URL_2 } from '../../api/constant';
import { useForm } from 'react-hook-form';
import { showToastNotification } from '../../utility/helper';
import InputField from '../../components/UI/Forms/InputField';
import ErrorMessage from '../../components/UI/Notifications/ErrorMessage';
import Button from '../../components/UI/Buttons/Button';
import { IUnit } from '../../interfaces/product';
import useConfirmationModal from '../../hooks/useConfirmationModal';
import ConfirmationModal from '../../components/UI/Modal/ConfirmationModal';

const Unit: React.FC = () => {
    const [units, setUnits] = useState<IUnit[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const { register, handleSubmit, formState: { errors }, reset, setValue } = useForm({ mode: 'onBlur' });
    const [loadingButton, setLoadingButton] = useState<boolean>(false);
    const [editingUnit, setEditingUnit] = useState<IUnit | null>(null);
    const { showModal, modalProps, confirmAction } = useConfirmationModal();

    const onSubmit = async (data: any) => {
        setLoadingButton(true);
        const postData = { title: data.title };

        try {
            if (editingUnit) {
                // Update unit
                await callApi(API_URL_2 + API_ENDPOINT.page + `unit/${editingUnit.id}`, { method: 'PUT', data: postData });
                showToastNotification('success', 'Unit updated successfully');
            } else {
                // Create new unit
                await callApi(API_URL_2 + API_ENDPOINT.page + 'unit', { method: 'POST', data: postData });
                showToastNotification('success', 'Unit added successfully');
            }

            reset();
            setEditingUnit(null);
            getUnits();
        } catch (error: any) {
            showToastNotification('danger', error.message);
        } finally {
            setLoadingButton(false);
        }
    };

    useEffect(() => {
        getUnits();
    }, []);

    const getUnits = async () => {
        try {
            setLoading(true);
            const response = await callApi(API_URL_2 + API_ENDPOINT.page + 'unit', { method: 'GET' });
            setUnits(response);
        } catch (error: any) {
            console.error('Failed to fetch units:', error.message);
        } finally {
            setLoading(false);
        }
    };

    const deleteUnit = async (id: string) => {
        try {
            await callApi(API_URL_2 + API_ENDPOINT.page + `unit/${id}`, { method: 'DELETE' });
            setUnits((prevUnits: IUnit[]) => prevUnits.filter((unit) => unit.id !== id));
        } catch (error: any) {
            console.error('Failed to delete unit:', error.message);
        }
    };

    const handleEditUnit = (unit: IUnit) => {
        setEditingUnit(unit);
        setValue('title', unit.title);
    };

    const handleDeleteClick = (id: string) => {
        confirmAction({
            title: 'Confirm Delete',
            message: 'Are you sure you want to delete this unit?',
            onConfirm: () => deleteUnit(id),
        });
    };

    return (
        <Layout>
            <div className='d-flex justify-content-between align-items-start'>
                <h1 className="app-page-title">Units</h1>
                {/* <button className='btn app-btn-primary d-flex align-items-center gap-1'><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C6.13261 0 6.25979 0.0526785 6.35355 0.146447C6.44732 0.240215 6.5 0.367392 6.5 0.5V5.5H11.5C11.6326 5.5 11.7598 5.55268 11.8536 5.64645C11.9473 5.74021 12 5.86739 12 6C12 6.13261 11.9473 6.25979 11.8536 6.35355C11.7598 6.44732 11.6326 6.5 11.5 6.5H6.5V11.5C6.5 11.6326 6.44732 11.7598 6.35355 11.8536C6.25979 11.9473 6.13261 12 6 12C5.86739 12 5.74021 11.9473 5.64645 11.8536C5.55268 11.7598 5.5 11.6326 5.5 11.5V6.5H0.5C0.367392 6.5 0.240215 6.44732 0.146447 6.35355C0.0526785 6.25979 0 6.13261 0 6C0 5.86739 0.0526785 5.74021 0.146447 5.64645C0.240215 5.55268 0.367392 5.5 0.5 5.5H5.5V0.5C5.5 0.367392 5.55268 0.240215 5.64645 0.146447C5.74021 0.0526785 5.86739 0 6 0Z" fill="white" />
                </svg> Add Units</button> */}
            </div>

            <div className="row">
                <div className="col-lg-8">
                    <div className="app-card app-card-orders-table shadow-sm mb-4 p-4">
                        <div className="app-card-body">
                            <div className="table-responsive">
                                <table className="table app-table-hover mb-0 text-left">
                                    <thead>
                                        <tr>
                                            <th className="cell">S.no.</th>
                                            <th className="cell">Unit</th>
                                            <th className="cell">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td className="text-center" colSpan={3}>Loading units...</td>
                                            </tr>
                                        ) : units.length === 0 ? (
                                            <tr>
                                                <td className="text-center" colSpan={3}>No units available to display.</td>
                                            </tr>
                                        ) : (
                                            units.map((unit, index) => (
                                                <tr key={unit.id}>
                                                    <td className="cell">#{index + 1}</td>
                                                    <td className="cell">{unit.title}</td>
                                                    <td className="cell">
                                                        <div className=' d-flex align-items-center gap-1'>
                                                            <a className="btn btn-success px-2 py-1 text-white" href="javascript:void(0)" onClick={() => handleEditUnit(unit)}><i className="bi bi-pen"></i></a>
                                                            <a className="btn btn-danger px-2 py-1 text-white" href="javascript:void(0)" onClick={() => handleDeleteClick(unit.id)}><i className="bi bi-trash3"></i></a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4">
                    <div className="app-card app-card-settings shadow-sm p-4">
                        <div className="app-card-body">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="row">
                                    <div className="mb-3 col-12">
                                        <InputField
                                            type="text"
                                            register={register('title', { required: 'Unit is required' })}
                                            name="title"
                                            label="Unit"
                                            placeholder="Enter unit"
                                        />
                                        <ErrorMessage message={errors.title?.message?.toString()} />
                                    </div>

                                </div>
                                <div className="col-12 text-end mt-3">
                                    <Button loading={loadingButton} className="btn btn-primary text-white px-5" type="submit" text={editingUnit ? 'Update' : 'Save'} />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <ConfirmationModal {...modalProps} show={showModal} />
        </Layout>
    );
};

export default Unit;
